module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAPCAYAAAA/I0V3AAAA+klEQVQokX2STWoCQRCFn4PrLF3qKrgNZOkhgkQwRsgigZC7eBwjZjazcEQCuYDZCt7AjdCvJvRk+tceCx7zQ31Vr6q7U1UVgvh+vQG5AAUgGylANe+Kpy7iEBlD5B1CDxJ4RZbZBUQ+ueSk1qG98qUH8giyawGljC3zHISdhI8QD7DW7Pce8+KQRdae05YsuNJpDipmfVBG0dAxmIeQcAqy02JL6wTKJoSS1jxQWOBtd3ZQPhmCctduq9aXqZ9dX0Cgegk+NGs5fW1L35I9Pn4ODvp8uAflNqhaXyFrK+jyD1lrqXma/+Lm0aFPfwvy93JbdbLpWloCwB/dvDYi0hM2ywAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/yellow.png
// module id = fcot
// module chunks = 1